import { useIsTabletOrMobileScreenSize } from '@app/utils/media-query';
import { IconButton, Typography } from '@material-ui/core';
import { ArrowBack, Close } from '@material-ui/icons';
import React, { ReactNode } from 'react';
import classes from './styles.module.css';
import cls from 'classnames';
import DIMENSIONS from '@app/config/dimensions';

const DEFAULT_MOBILE_COLOR = '#e53935';
const DEFAULT_DESKTOP_COLOR = '#fff';

const DEFAULT_DESKTOP_TINT_COLOR = '#999';
const DEFAULT_MOBILE_TINT_COLOR = '#fff';

type Props = {
  mobile?: {
    title?: string;
    color?: string;
    tintColor?: string;
  };
  desktop?: {
    contentWidth: string | number;
    className?: string;
  };
  onCloseButtonClick: () => void;
  onBackButtonClick: () => void;
  RightSide?: ReactNode;
};

export default function AppBar({ mobile, desktop, onCloseButtonClick, onBackButtonClick, RightSide }: Props) {
  const shouldUseMobileAppBar = useIsTabletOrMobileScreenSize();

  if (shouldUseMobileAppBar) {
    return (
      <div
        className={classes.mobile}
        style={{ backgroundColor: mobile?.color ?? DEFAULT_MOBILE_COLOR, height: DIMENSIONS.APP_BAR.HEIGHT }}
      >
        <div style={{ height: DIMENSIONS.APP_BAR.HEIGHT }}>
          <IconButton onClick={onBackButtonClick}>
            <ArrowBack style={{ color: mobile?.tintColor ?? DEFAULT_MOBILE_TINT_COLOR }} />
          </IconButton>
          {mobile?.title && (
            <Typography
              style={{ color: mobile.tintColor ?? DEFAULT_MOBILE_TINT_COLOR }}
              classes={{
                root: classes.mobileTitle,
              }}
            >
              {mobile.title}
            </Typography>
          )}
        </div>
        {RightSide && RightSide}
      </div>
    );
  }

  return (
    <div
      className={cls(classes.desktop, desktop?.className ?? '')}
      style={{
        backgroundColor: DEFAULT_DESKTOP_COLOR,
        width: desktop?.contentWidth ?? 300,
      }}
    >
      <IconButton onClick={onCloseButtonClick} size="small">
        <Close style={{ color: DEFAULT_DESKTOP_TINT_COLOR }} />
      </IconButton>
    </div>
  );
}
